<template>
    <div class="bid_w_con">
        <span class="bid_title">프로젝트 한줄소개를 입력해주세요</span><br>
        <input id="bid_title_input" placeholder="한줄소개" v-model="title"><br>
        <span class="bid_title">프로젝트 내용을 알려주세요</span>
        <textarea class="bidding_text_area" v-model="bid_content">        
        </textarea>
        <span class="bid_title">첨부하실 파일이 있으신가요?</span><br>
        <div @click="attach_file" class="file_attach_btn">파일 첨부/변경</div>
        <span id="bid_attached_file"></span>       
    </div>
</template>
<script>
import EventBus from "@/EventBus.js";
export default {
    props:["content"],
    data(){
        return {
            title:"",
            bid_content:"※상세한 업무 내용\
                    Ex) 주요 List, 작업분량(장 수) 등 \
                    ※참고 / 유의 사항"
        }
    },
    methods:{
      attach_file(){
          $("#attached_file").click();
      },     
      nextStep(){EventBus.$emit("bidding_next",{title:this.title, bid_content:this.bid_content})},
    },
}
</script>
<style scoped lang="scss">
.bid_w_con{
    padding: 25px 50px;    
    .bid_title{
        font-size: 25px;
        font-weight: bold;
        color: #373737;
        line-height: 1;
        margin-bottom: 15px;
        margin-top: 15px;
        display: inline-block;
    }
    .bidding_text_area{
        width: 700px;
        margin-left: 50px;
        display: block;
        box-sizing: border-box;
        font-size: 13px;
        font-weight: normal;        
        border: 1px solid #d7d7d7;
        padding: 10px;       
        color: #373737;
        outline: none;
        height: 100px;
        resize:none;
    }
    .file_attach_btn{
        margin-left: 50px;
        color: #fff;    
        background-color: #f27824;
        display:inline-block;
        padding: 5px;
        font-size: 12px;
        cursor: pointer;
    }
    #bid_title_input{
        margin-left: 50px;
        width: 700px;
        height: 40px;
        border: 1px solid #d7d7d7;
        padding: 5px;
        padding-left: 10px;
        line-height: 38px;
        font-size: 14px;
    }
      .prev{
        display: inline-block;
        margin: 0 7px 0 0;
        padding: 0 5px;
        text-decoration: none;
        text-align: center;
        font-size: 13px;        
        color: #fff;
        outline-style: none;
        background-color: #f27824;
        border: 1px solid #f27824;
        line-height: 31px;       
        font-weight: bold;
        width: 71px;
        height: 31px;
        float: left;
        margin:30px;
        cursor: pointer;
    }
    .next{
        display: inline-block;
        margin: 0 7px 0 0;
        padding: 0 5px;
        text-decoration: none;
        text-align: center;
        font-size: 13px;        
        color: #fff;
        outline-style: none;
        background-color: #f27824;
        border: 1px solid #f27824;
        line-height: 31px;       
        font-weight: bold;
        width: 71px;
        height: 31px;
        float: right;
        margin: 30px;
        cursor: pointer;
    }
}
</style>


// WEBPACK FOOTER //
// src/SPA/Components/Bidding/BiddingContent.vue